import { Component, inject } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [],
  template: `
    @if (toastService.toasts().length) {
      <div class="toast toast-top toast-end fixed z-[1000]">
        @for (toast of toastService.toasts(); track toast.id) {
          <div class="alert shadow-lg transition-all duration-300"
               [class.alert-success]="toast.type === 'success'"
               [class.alert-error]="toast.type === 'error'"
               [class.alert-info]="toast.type === 'info'"
          >
            @if (toast.type === 'success') {
              <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            } @else if (toast.type === 'error') {
              <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            }
            <span>{{ toast.message }}</span>
          </div>
        }
      </div>
    }
  `
})
export class ToastComponent {
  toastService = inject(ToastService);
}
